import { Box, Typography, Button } from "@mui/material";
import { useEffect, useRef } from "react";
import { useFloatingBubbles } from "../../../context/floating-bubbles/FloatingBubblesContext";
import { Contact } from "../_types/internalContacts.types";
import { getContactTitle } from "../_utils/internalContacts.utils";
import { useInternalWebRTC } from "../_context/InternalWebRTCContext";

interface InternalContactsCallViewProps {
  contact: Contact;
  onEndCall: () => void;
}

export const InternalContactsCallView = ({
  contact,
  onEndCall,
}: InternalContactsCallViewProps) => {
  const { internalCallView, cancelOutgoing, phase } = useInternalWebRTC();
  const { openCalls } = useFloatingBubbles();
  const hadActiveCallRef = useRef(false);

  useEffect(() => {
    if (phase !== "idle") {
      hadActiveCallRef.current = true;
    }
  }, [phase]);

  useEffect(() => {
    if (internalCallView === "outgoing-ringing" || internalCallView === "in-call") {
      openCalls();
    }
  }, [internalCallView, openCalls]);

  useEffect(() => {
    if (phase === "idle" && hadActiveCallRef.current) {
      hadActiveCallRef.current = false;
      onEndCall();
    }
  }, [onEndCall, phase]);

  if (internalCallView === "in-call") {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography color="text.secondary" fontSize={14}>
          Call connected. Manage it from the Calls tab.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        p: 2.5,
        gap: 2,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography sx={{ fontSize: 15, fontWeight: 600, textAlign: "center" }}>
        Calling {getContactTitle(contact)}...
      </Typography>
      <Button
        variant="outlined"
        color="error"
        size="small"
        onClick={() => void cancelOutgoing()}
      >
        Cancel
      </Button>
    </Box>
  );
};
